import axios from "@/axios";
import store from "@/store/index";
import dc from "@/component/utils/DataChk";

let items = [];
let tempItems = [];

export default {
    async getPageItems(url, search, page, isModal) {
        let res = [];

        if (!this.nullChk(isModal)) {
            items = tempItems;
        }

        const pagingInfo = page;
        const searchInfo = search;

        if (
            pagingInfo.type === 1 ||
            pagingInfo.type === 3 ||
            this.getRange(pagingInfo.currentPage + pagingInfo.pageNum, pagingInfo.limitNum) !==
                this.getRange(pagingInfo.prePage, pagingInfo.limitNum)
        ) {
            const cp = pagingInfo.currentPage === -1 ? 1 : pagingInfo.currentPage;

            const pageCalc = Math.max(1, cp + pagingInfo.pageNum);
            const range = this.getRange(pageCalc, pagingInfo.limitNum);

            searchInfo.skipCount = Math.max(
                range * Number(pagingInfo.perPage) * pagingInfo.limitNum,
                0
            );

            searchInfo.limit = Number(pagingInfo.perPage) * pagingInfo.limitNum + 1;

            searchInfo.nextKey = "";
            searchInfo.preKey = "";

            if (pagingInfo.type === 1) {
                pagingInfo.currentPage = -1;
                pagingInfo.pageNum = 0;
                searchInfo.skipCount = 0;
            }

            if (pagingInfo.type === 3) {
                const page1 =
                    pagingInfo.currentPage + pagingInfo.pageNum - range * pagingInfo.limitNum;

                const page2 = Math.ceil(this.getRows() / Number(pagingInfo.perPage));

                if (
                    this.getRows() < Number(pagingInfo.perPage) * pagingInfo.limitNum &&
                    page1 > page2
                ) {
                    pagingInfo.currentPage = page2;
                }

                searchInfo.changePerpage = true;
            }

            const totalItems = Number(String(pagingInfo.total).replace(/,/g, "")) || 0;

            const totalPages = Math.ceil(totalItems / Number(pagingInfo.perPage));

            const currentPageNum = cp + pagingInfo.pageNum;

            if (pagingInfo.type !== 1 && currentPageNum > pagingInfo.prePage) {
                if (currentPageNum < totalPages) {
                    const nextIndex = Number(pagingInfo.perPage) * pagingInfo.limitNum - 1;

                    searchInfo.nextKey =
                        items[nextIndex] && items[nextIndex].id ? items[nextIndex].id : "";
                } else {
                    searchInfo.nextKey = "";
                }
            } else if (pagingInfo.type !== 1 && currentPageNum < pagingInfo.prePage) {
                if (currentPageNum > 1) {
                    searchInfo.preKey = items[0] && items[0].id ? items[0].id : "";
                } else {
                    searchInfo.preKey = "";
                }
            }

            res = await this.request(url, searchInfo, pagingInfo, isModal);
        } else {
            res = this.changeViewItems(pagingInfo);
        }

        return res;
    },

    nullChk(val) {
        return val !== undefined && val !== null;
    },

    async request(url, search, pagingInfo, isModal) {
        const searchInfo = search;

        store.commit("loading/SHOW_LOADING");

        try {
            const response = await axios.post(url, searchInfo);

            let viewItems = [];

            if (response.data.resType === "RES_OK" && response.data.resList.length > 0) {
                items = response.data.resList;

                if (!this.nullChk(isModal)) {
                    tempItems = items;
                }

                viewItems = this.changeViewItems(pagingInfo);

                if (pagingInfo.type === 3) {
                    searchInfo.changePerpage = false;
                }
            }

            return viewItems;
        } catch (error) {
            console.log(error);
            return [];
        } finally {
            store.commit("loading/HIDE_LOADING");
        }
    },

    changeViewItems(page) {
        const pagingInfo = page;

        const cp = pagingInfo.currentPage === -1 ? 1 : pagingInfo.currentPage;

        const range = this.getRange(cp + pagingInfo.pageNum, pagingInfo.limitNum);

        const page1 = cp + pagingInfo.pageNum - range * pagingInfo.limitNum;

        const page2 = Math.ceil(this.getRows() / Number(pagingInfo.perPage));

        let currentPage = page1;

        if (this.getRows() < Number(pagingInfo.perPage) * pagingInfo.limitNum && page1 > page2) {
            currentPage = page2;
        }

        const start = (currentPage - 1) * Number(pagingInfo.perPage);
        const end = start + Number(pagingInfo.perPage);

        const viewItems = (items || []).slice(start, end);

        pagingInfo.prePage = cp + pagingInfo.pageNum;

        return viewItems;
    },

    getRange(page, limitNum) {
        return Math.floor(parseFloat((page / limitNum - 0.1).toFixed(1)));
    },

    getRows() {
        return (items || []).length;
    },

    async listPaging(inData, pagingInfo) {
        const cp = pagingInfo.currentPage === -1 ? 1 : pagingInfo.currentPage;

        const page1 = cp + pagingInfo.pageNum;

        const page2 = Math.ceil((inData || []).length / Number(pagingInfo.perPage));

        let currentPage = page1;

        if (
            (inData || []).length < Number(pagingInfo.perPage) * pagingInfo.limitNum &&
            page1 > page2
        ) {
            currentPage = page2;
        }

        const start = (currentPage - 1) * Number(pagingInfo.perPage);
        const end = start + Number(pagingInfo.perPage);

        const viewItems = (inData || []).slice(start, end);

        pagingInfo.prePage = cp + pagingInfo.pageNum;

        return viewItems;
    },

    async total(url, search) {
        const searchInfo = search;

        try {
            const response = await axios.post(url, searchInfo);

            if (response.data.resType === "RES_OK") {
                return dc.commaMaker(response.data.resMsg);
            }

            return -1;
        } catch (error) {
            console.log(error);
            return -1;
        }
    },
};
